import { useEffect } from 'react';
import { useSession } from './state/session';
import { SignInScreen } from './screens/SignInScreen';
import { MapScreen } from './screens/MapScreen';
import { startOutbox } from './lib/outbox';
import { startAudioLifecycle } from './lib/audio';
import { A2HSPrompt } from './components/A2HSPrompt';
import { AccountBootstrap } from './components/AccountBootstrap';

// Start audio listeners at app boot, before sign-in, so the sign-in tap
// itself counts as the user gesture that unlocks the shared audio element on
// iOS. Without this, users who sign in and then passively receive messages
// never unlock audio and hear nothing.
startAudioLifecycle();

export function App() {
  const { session, loading } = useSession();

  useEffect(() => {
    if (!session) return;
    startOutbox();
  }, [session]);

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner" />
        <style>{`
          .app-loading { min-height: 100vh; display: flex; align-items: center; justify-content: center; }
          .spinner {
            width: 28px; height: 28px;
            border: 3px solid var(--divider);
            border-top-color: var(--accent);
            border-radius: 50%;
            animation: spin 0.8s linear infinite;
          }
          @keyframes spin { to { transform: rotate(360deg); } }
        `}</style>
      </div>
    );
  }

  return (
    <>
      {session ? (
        <AccountBootstrap session={session}>
          <MapScreen session={session} />
        </AccountBootstrap>
      ) : (
        <SignInScreen />
      )}
      {session && <A2HSPrompt />}
    </>
  );
}
